/* eslint-disable camelcase */
/* eslint-disable eqeqeq */
import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';

// icons
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ContactMailIcon from '@material-ui/icons/ContactMail';

// components
import CardTitle from 'src/components/sharedComponents/CardTitle';
import { ScreenLoading2 } from 'src/components/sharedComponents/ScreenLoading/index';
import CustomInput from 'src/components/sharedComponents/CustomInput/CustomInput';
import Card from 'src/components/sharedComponents/Card/Card';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import CardFooter from 'src/components/sharedComponents/Card/CardFooter';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import CardIcon from 'src/components/sharedComponents/Card/CardIcon';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import Chip from '@material-ui/core/Chip';
import { permitsList, minPermisos } from 'src/constants/index';
import canUseState from 'src/utils/canUseState';
import Search from 'src/components/sharedComponents/SearchInput';
import { Context } from 'src/context/Contex';
import { useStyles } from './styles';
// context

const UserDestinatairePage = ({
  user,
  search,
  loading,
  destinataire,
  checkPassword,
  destinataries,
  handleChangeValue,
  handleUpdateUser,
  handleUpdatePassword,
  handleAddDestinataire,
  handleSearchDestinatary,
  handleDeleteDestinatarie,
}) => {
  const { permisos } = useContext(Context);
  const classes = useStyles();
  const mensaje = 'La contraseña debe tener al menos 9 caracteres';

  if (loading) {
    return <ScreenLoading2 />;
  }
  return (
    <section style={{ margin: '10px' }}>
      <CardTitle title="Asignación de permisos" />
      <Grid justifyContent="center" container spacing={2}>
        <Grid item xs={12} md={8} sm={6}>
          <form onSubmit={handleUpdateUser}>
            <Card>
              <CardHeader color="customAuteco" stats icon>
                <CardIcon color="customAuteco">
                  <ContactMailIcon />
                </CardIcon>
              </CardHeader>
              <CardBody>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4} sm={12}>
                    <CustomInput
                      labelText="Nombre"
                      id="name"
                      value={user.nombre}
                      formControlProps={{
                        required: true,
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) => handleChangeValue(event.target.value, 'nombre'),
                        type: 'text',
                        autoComplete: 'off',
                        defaultValue: user.nombre,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} sm={12}>
                    <CustomInput
                      labelText="Apellido"
                      id="lastname"
                      value={user.apellido}
                      required
                      formControlProps={{
                        required: true,
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) => handleChangeValue(event.target.value, 'apellido'),
                        type: 'text',
                        autoComplete: 'off',
                        defaultValue: user.apellido,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} sm={12}>
                    <CustomInput
                      labelText="Correo"
                      id="correo"
                      value={user.correo}
                      required
                      formControlProps={{
                        required: true,
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) => handleChangeValue(event.target.value, 'correo'),
                        type: 'email',
                        defaultValue: user.correo,
                      }}
                    />
                  </Grid>
                </Grid>
              </CardBody>
              <CardFooter>
                <Button type="onSubmit " color="warning">
                  Actualizar Datos
                </Button>
              </CardFooter>
            </Card>
          </form>
        </Grid>
        <Grid item xs={12} md={4} sm={6}>
          <Card>
            <CardHeader color="customAuteco" stats icon>
              <CardIcon color="customAuteco">
                <VpnKeyIcon />
              </CardIcon>
            </CardHeader>
            <CardBody>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <CustomInput
                    labelText="Contraseña"
                    id="password"
                    value={user.contraseña}
                    success={checkPassword}
                    required
                    formControlProps={{
                      required: true,
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: 'text',
                      onChange: (event) => handleChangeValue(event.target.value, 'contraseña'),
                      autoComplete: 'off',
                    }}
                  />
                  {!checkPassword && user.contraseña?.length > 1 ? (
                    <p>{mensaje}</p>
                  ) : null}
                </Grid>
              </Grid>
            </CardBody>
            <CardFooter>
              <Button onClick={handleUpdatePassword} color="warning">
                Actualizar Contraseña
              </Button>
            </CardFooter>
          </Card>
        </Grid>
        <Grid item xs={12} md={12} sm={12}>
          <Card>
            <CardBody>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Card>
                    <CardHeader>
                      <Grid container>
                        <Grid item xs={12} sm={5}>
                          <h3>Destinatarios</h3>
                          <p>Seleccione un destinatario</p>
                        </Grid>
                      </Grid>
                      <Search
                        handleSearch={handleSearchDestinatary}
                        search={search}
                      />
                    </CardHeader>
                    <CardBody className={classes.cardBody}>
                      {destinataries.map((item) => {
                        const canUse = canUseState(
                          destinataire,
                          item,
                          'destinatario_id',
                          'Cliente_Destinatario',
                        );
                        return (
                          <div key={item.id}>
                            <Chip
                              id={item.Nombre_Cliente_Destinatario}
                              label={item.Nombre_Cliente_Destinatario?.toUpperCase()}
                              clickable
                              className={classes.chip}
                              color={!canUse ? 'default' : 'primary'}
                              variant="outlined"
                              onClick={
                                handleAddDestinataire(item)
                                // permisos[permitsList.ADMIN_USER_INVENTARIO] >=
                                // minPermisos.CREAR
                                //   ? handleAddDestinataire(item)
                                //   : handleAddDestinataire(item)
                              }
                            />
                          </div>
                        );
                      })}
                    </CardBody>
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Card>
                    <CardHeader>
                      <h3>Asignados</h3>
                      <p>Destinatario seleccionado</p>
                    </CardHeader>
                    <CardBody className={classes.cardBody}>
                      {destinataire.map((item) => {
                        const Client_name_index = destinataries.findIndex(
                          (value) => value.Cliente_Destinatario === item.destinatario_id,
                        );
                        return (
                          <div key={item.Cliente_Destinatario}>
                            <Chip
                              id={item.Cliente_Destinatario}
                              label={destinataries[
                                Client_name_index
                              ]?.Nombre_Cliente_Destinatario?.toUpperCase()}
                              clickable
                              className={classes.chip}
                              color="primary"
                              variant="outlined"
                              onClick={
                                permisos[permitsList.ADMIN_USER_INVENTARIO]
                                >= minPermisos.ELIMINAR
                                  ? handleDeleteDestinatarie(item)
                                  : null
                              }
                            />
                          </div>
                        );
                      })}
                    </CardBody>
                  </Card>
                </Grid>
              </Grid>
            </CardBody>
          </Card>
        </Grid>
      </Grid>
    </section>
  );
};

export default UserDestinatairePage;
